module.exports = __webpack_public_path__ + "static/img/course3.be4ab429.jpg";